import { styled, TextField, Button } from '@mui/material';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: theme.spacing(1.5),
    transition: "all 0.2s ease-in-out",
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: "1rem",
    fontWeight: 400,
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#ff9800",
      boxShadow: "0 2px 8px rgba(255, 152, 0, 0.1)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ff9800",
      boxShadow: "0 4px 12px rgba(255, 152, 0, 0.2)",
    },
  },
  "& .MuiInputBase-input": {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: "1rem",
    fontWeight: 400,
    "&::placeholder": {
      opacity: 0.7,
      fontWeight: 400,
    },
  },
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  textTransform: "none",
  fontWeight: 600,
  fontSize: "1rem",
  padding: theme.spacing(1.5, 3),
  backgroundColor: "#ff9800",
  transition: "all 0.2s ease-in-out",
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  letterSpacing: "0.025em",
  "&:hover": {
    backgroundColor: "#f57c00",
    transform: "translateY(-1px)",
    boxShadow: "0 4px 12px rgba(255, 152, 0, 0.3)",
  },
  "&:disabled": {
    backgroundColor: "rgba(0,0,0,0.12)",
    transform: "none",
  },
}));